import {
  OrderCardResourceTypeMappings,
  OrderResourceTypeMappings,
} from '@aa/nest/resource';
import { createAction, props } from '@ngrx/store';
import { createBaseResourceActions } from '../create-base-resource-actions';

// @aa:gen-ignore

const domainSlug = '[ORDER CARD]';
export const orderCardActions = {
  ...createBaseResourceActions<OrderCardResourceTypeMappings>(domainSlug),
  createCardWithAttributes: createAction(
    `${domainSlug} Create Card with Attributes`,
    props<{
      cardData: OrderCardResourceTypeMappings['createDTO'];
      offeredServicesIds?: number[];
      attributes: { fieldName: string; value: any }[];
    }>(),
  ),
  updateCardWithAttributes: createAction(
    `${domainSlug} Update Card with Attributes`,
    props<{
      id: number;
      cardUpdates: OrderCardResourceTypeMappings['updateDTO'];
      offeredServicesIds?: number[];
      draftOfferedServicesIds?: number[];
      attributes: {
        orderCardId?: number;
        orderCardAttributeTypeId?: number;
        fieldName: string;
        value: any;
      }[];
      updateInvoiceForOrderId?: number;
      customPrices?: { offeredServiceId: number; price: number }[];
    }>(),
  ),
  autoAdjustInvoiceForOrderAndReloadCard: createAction(
    `${domainSlug} Auto Adjust Invoice for Order and Reload Card`,
    props<{
      orderCardId: number;
      orderId: OrderResourceTypeMappings['resourcePrimaryKeyT'];
    }>(),
  ),
  notifyCustomerOfCardChanges: createAction(
    `${domainSlug} Notify Customer of Card Changes`,
    props<{ orderCardId: number }>(),
  ),
  approveCardChanges: createAction(
    `${domainSlug} Approve Card Changes`,
    props<{ orderCardId: number; messageId: number; metadata: any }>(),
  ),
  rejectCardChanges: createAction(
    `${domainSlug} Reject Card Changes`,
    props<{ orderCardId: number; messageId: number; metadata: any }>(),
  ),
  cardUpdated: createAction(
    `${domainSlug} Card Updated`,
    props<{
      id: number;
      updateInvoicingForOrderId?: number;
      customPrices?: { offeredServiceId: number; price: number }[];
    }>(),
  ),
};
